module.exports = __webpack_public_path__ + "img/mperaheader.c3408a5b.png";